{
    "CONFIRM": "Confirmação",
    "SURE": "Tem certeza que deseja sair da tela?",

    "CANCEL": "Cancelar",
    "YES": "Sim"
}